import React, { useEffect, useState } from 'react'
import { Box, Heading, Text, Spinner, Button } from '@chakra-ui/react'
import { fetchWithoutAuth } from './apiClient'
import { useSearchParams, useNavigate } from 'react-router-dom'

export default function Unsubscribe() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('t')
  const [status, setStatus] = useState(token ? 'loading' : 'missing') // loading | success | error | missing
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    if (!token) return
    async function doUnsub() {
      try {
        const resp = await fetchWithoutAuth('/api/waitlist/unsubscribe', {
          method: 'POST',
          body: JSON.stringify({ token }),
        })
        if (resp.ok) {
          setStatus('success')
          setMessage('You have been unsubscribed. Sorry to see you go!')
        } else {
          setStatus('error')
          setMessage('This link is invalid or has already been used.')
        }
      } catch (err) {
        setStatus('error')
        setMessage('This link is invalid or has already been used.')
      }
    }
    doUnsub()
  }, [token])

  return (
    <Box p={6} maxW="md" mx="auto">
      {status === 'loading' && (
        <Box textAlign="center">
          <Spinner />
          <Text mt={3}>Processing unsubscribe...</Text>
        </Box>
      )}

      {status === 'success' && (
        <Box>
          <Heading size="md">You are unsubscribed</Heading>
          <Text>{message}</Text>
          <Button mt={4} onClick={() => navigate('/login')}>
            Return to Login
          </Button>
        </Box>
      )}

      {status === 'error' && (
        <Box>
          <Heading size="md">Unable to unsubscribe</Heading>
          <Text>{message}</Text>
          <Button mt={4} onClick={() => navigate('/login')}>
            Return to Login
          </Button>
        </Box>
      )}

      {status === 'missing' && (
        <Box>
          <Heading size="md">Unsubscribe link required</Heading>
          <Text>
            This page needs a one-click unsubscribe link. Please use the latest email from ekkos or contact support if you need help.
          </Text>
          <Button mt={4} onClick={() => navigate('/login')}>
            Return to Login
          </Button>
        </Box>
      )}
    </Box>
  )
}
